const DOCUMENT_STATUS: Record<string, string> = {
  DRAFT: "Draft",
  CREATED: "Created",
  0: "Draft",
  1: "Created",
  2: "Discard",
  4: "Partially Received",
  5: "Fully Received",
  6: "Excess Received",
  7: "Quality Report Created",
  8: "Sales Quotation Created",
  9: "OC Created",
  10: "Partially Delivered",
  11: "Completely Delivered",
  12: "Partially Billing",
  13: "Completely Billed",
  14: "Partially Ordered",
  15: "Partially Ordered, Partially Received",
  16: "Ordered",
  17: "Fully Ordered, Partially Received",
  18: "Fully Ordered, Fully Received",
  19: "Partially Delivered, Partially Billing",
  20: "Partially Delivered, Completely Billed",
  21: "Completely Delivered, Partially Billing",
  22: "Completely Delivered, Completely Billed",
  23: "Partially Billing, Partially Received",
  24: "Partially Billing, Fully Received",
  25: "Partially Billing, Excess Received",
  26: "Completely Billed, Partially Received",
  27: "Completely Billed, Fully Received",
  28: "Completely Billed, Excess Received",
  29: "Request for Approval",
  30: "Rejected",
  31: "Partially Returned",
  32: "Fully Returned",
  33: "Partially Delivered, Partially Returned",
  34: "Completely Delivered, Partially Returned",
  35: "Partially Billing, Partially Returned",
  36: "Completely Billed, Partially Returned",
  37: "Partially Delivered, Completely Returned",
  38: "Completely Delivered, Completely Returned",
  39: "Partially Billing, Completely Returned",
  40: "Completely Billed, Completely Returned",
  41: "Partially Delivered, Partially Billing, Partially Returned",
  42: "Partially Delivered, Completely Billed, Partially Returned",
  43: "Completely Delivered, Partially Billing, Partially Returned",
  44: "Completely Delivered, Completely Billed, Partially Returned",
  45: "Partially Delivered, Partially Billing, Completely Returned",
  46: "Partially Delivered, Completely Billed, Completely Returned",
  47: "Completely Delivered, Partially Billing, Completely Returned",
  48: "Completely Delivered, Completely Billed, Completely Returned",
  49: "Partially Invoice Created",
  50: "Invoice Created",
};

const DRAFT_DOC_TYPE: Record<string, string> = {
  "Sales Lead": "salesLead",
  "Sales Quotation": "salesQuotation",
  "Sales Order": "salesOrder",
  "Delivery Challan": "deliveryChallan",
  "Proforma Invoice": "proformaInvoice",
  Invoice: "invoice",
  "Debit Note": "debitNote",
  "Credit Note": "creditNote",
  "Sales Return": "salesReturn",
  "Purchase Order": "purchaseOrder",
  "Goods Received Note": "goodsReceivedNote",
  "Quality Report": "qualityReport",
  "Purchase Invoice": "purchaseInvoice",
  "Purchase Return": "purchaseReturn",
  "Purchase Debit Note": "purchaseDebitNote",
  "Purchase Credit Note": "purchaseCreditNote",
  "Purchase Request": "purchaseRequest",
  "Request for Quotation": "requestForQuotation",
  "Service Order": "serviceOrder",
  "Service Confirmation": "serviceConfirmation",
  "Service Challan": "serviceChallan",
  "Service Confirmation Challan": "serviceConfirmationChallan",
  "Service Grn": "serviceGrn",
  "Service Confirmation Grn": "serviceConfirmationGrn",
  "Service Qr": "serviceQr",
  "Service Confirmation Qr": "serviceConfirmationQr",
  "Service Proforma Invoice": "serviceProformaInvoice",
  "Service Confirmation Proforma Invoice": "serviceConfirmationProformaInvoice",
  "Service Invoice": "serviceInvoice",
  "Service Confirmation Invoice": "serviceConfirmationInvoice",
  "Service Credit Note": "serviceCreditNote",
  "Service Confirmation Credit Note": "serviceConfirmationCreditNote",
  "Service Debit Note": "serviceDebitNote",
  "Service Confirmation Debit Note": "serviceConfirmationDebitNote",
  "Stock Transfer Delivery Challan": "stockTransferDeliveryChallan",
  "Gate Entry": "gateEntry",
  "Packaging List": "packagingList",
};

const PRODUCTION_STATUS: Record<string, string> = {
  1: 'In Planning',
  2: 'Ongoing',
  3: 'On Hold',
  4: 'Completed'
}

export const AppConstants = {
  APP_NAME: "EASEMARGIN",
  APP_API_URL: "https://testapi.easemargin.com/",
  API_METHOD: {
    GET: "GET",
    POST: "POST",
  },
  STORE_TYPE_MAPPING: {
    IN_STOCK: {
      ENTITY_ID: "1",
      DISPLAY_STRING: "In Stock",
    },
    REJECT: {
      ENTITY_ID: "2",
      DISPLAY_STRING: "Reject",
    },
  },
  ADDRESS_TYPE_MAPPING: {
    DELIVERY_ADDRESSES: {
      ENTITY_ID: 1,
      DISPLAY_STRING: "Delivery Address",
    },
    BILLING_ADDRESSES: {
      ENTITY_ID: 2,
      DISPLAY_STRING: "Billing Address",
    },
  },
  ITEM_TYPES: {
    BUY: {
      ITEM_TYPE: "Buy",
      ITEM_TYPE_ID: 1,
    },
    SELL: {
      ITEM_TYPE: "Sell",
      ITEM_TYPE_ID: 2,
    },
    BOTH: {
      ITEM_TYPE: "Both",
      ITEM_TYPE_ID: 3,
    },
  },
  ITEM_CATEGORIES: {
    RAW_MATERIALS: {
      ITEM_CATEGORY: "Raw Materials",
      ITEM_CATEGORY_ID: 1,
    },
    FINISHED_GOODS: {
      ITEM_CATEGORY: "Finished Goods",
      ITEM_CATEGORY_ID: 2,
    },
    CONSUMABLES: {
      ITEM_CATEGORY: "Consumables",
      ITEM_CATEGORY_ID: 3,
    },
  },

  ITEM_TAX_TYPES: {
    INCLUSIVE: {
      ITEM_TAX: "Inclusive",
      ITEM_TAX_ID: 1,
    },
    EXCLUSIVE: {
      ITEM_TAX: "Exclusive",
      ITEM_TAX_ID: 2,
    },
  },
  ADDRESS_TYPE: {
    DELIVERY: {
      ADDRESS_NAME: "Delivery Address",
      ADDRESS_ID: 1,
    },
    BILLING: {
      ADDRESS_NAME: "Billing Address",
      ADDRESS_ID: 2,
    },
  },
  COMPANY_TYPE_MAPPING: {
    BUYER: {
      COMPANY_TYPE: "Buyer",
      COMPANY_TYPE_ID: 1,
    },
    SELLER: {
      COMPANY_TYPE: "Seller",
      COMPANY_TYPE_ID: 2,
    },
    BOTH: {
      COMPANY_TYPE: "Both",
      COMPANY_TYPE_ID: 3,
    },
  },
  LOGISTIC_DETAILS: {
    LOGISTIC_DETAILS_LABEL: "Logistic Details",
    WRITE_LOGISTIC_DETAIL: "Logistic detail here",
  },
  ADDITIONAL_DETAIL: {
    WRITE_ADDITIONAL_DETAIL: "Write additional detail here",
    ADDITIONAL_DETAILS_LABEL: "Additional Details",
  },
  COMMENT_INPUT: {
    WRITE_COMMENT_INPUT: "Write comment here",
    COMMENT_INPUT_LABEL: "Comment",
  },
  ATTACHMENTS_DETAIL: {
    ATTACHMENTS_LABEL: "Attachments",
    ATTACHMENTS_UPLOAD_DETAILS:
      "Recommended file size up to 5MB, maximum 5 files.",
  },
  VISITOR_IMAGE_DETAIL: {
    VISITOR_IMAGE_LABEL: "Visitor Image",
    VISITOR_IMAGE_UPLOAD_DETAILS:
      "Upload or capture a single image, recommended file size up to 5MB.",
  },
  SIGNATURE_DETAIL: {
    SIGNATURE_LABEL: "Signature",
    UPLOAD_LABEL: "Upload",
    SIGNATURE_UPLOAD_DETAILS:
      "Recommended resolution is 200x60 with file size of 500kb.",
  },
  TERMS_AND_CONDITIONS: {
    TERMS_AND_CONDITIONS_LABEL: "Terms and Conditions.",
  },
  SAVE_BUTTON: {
    SAVE_DRAFT_BUTTON: "Save as Draft",
    SAVE_DRAFT_UPDATE_BUTTON: "Update Draft",
    SAVE_BUTTON: "Save",
    UPDATE_BUTTON: "Update",
    DISABLE_ROUNDING: "Disable Rounding",
    ENABLE_ROUNDING: "Enable Rounding",
  },
  BACK_TO_DOCUMENTS_BUTTONS: "Back to Documents",
  EDIT_COMPANY_DETAILS: "Edit Company Details.",

  BACK_TO_REPORT: "Back to Report",

  MANAGE_CATEGORIES_CONSTANTS: {
    ABOUT_CATEGORIES_MESSAGE:
      "You can easily manage Categories, Subcategories, and Microcategories by adding new ones, editing existing ones, or deleting any you no longer need. This helps keep your content organized and easy to navigate.",
    CATEGORY: "Category",
    SUB_CATEGORY: "Subcategory",
    MICRO_CATEGORY: "Micro Category",
    ADD_SUB_CATEGORY: "Add Sub Category",
    ADD_MICRO_CATEGORY: "Add Micro Category",
  },

  DOCUMENT_TYPE: {
    SALES_LEAD: "Sales Lead",
    SALES_QUOTATION: "Sales Quotation",
    SALES_ORDER: "Sales Order",
    DELIVERY_CHALLAN: "Delivery Challan",
    INVOICE: "Invoice",
    PROFORMA_INVOICE: "Proforma Invoice",
    SALES_RETURN: "Sales Return",
    PURCHASE_ORDER: "Purchase Order",
    GOODS_RECEIVED_NOTE: "Goods Received Note",
    QUALITY_REPORT: "Quality Report",
    PURCHASE_INVOICE: "Purchase Invoice",
    DEBIT_NOTE: "Debit Note",
    CREDIT_NOTE: "Credit Note",
    PURCHASE_RETURN: "Purchase Return",
    PURCHASE_DEBIT_NOTE: "Purchase Debit Note",
    PURCHASE_CREDIT_NOTE: "Purchase Credit Note",
    PURCHASE_REQUEST: "Purchase Request",
    REQUEST_FOR_QUOTATION: "Request for Quotation",
    SERVICE_ORDER: "Service Order",
    SERVICE_CHALLAN: "Service Challan",
    SERVICE_GRN: "Service Grn",
    SERVICE_QR: "Service Qr",
    SERVICE_PROFORMA_INVOICE: "Service Proforma Invoice",
    SERVICE_INVOICE: "Service Invoice",
    SERVICE_CREDIT_NOTE: "Service Credit Note",
    SERVICE_DEBIT_NOTE: "Service Debit Note",
    STOCK_TRANSFER_DELIVERY_CHALLAN: "Stock Transfer Delivery Challan",
    SERVICE_CONFIRMATION: "Service Confirmation",
    SERVICE_CONFIRMATION_CHALLAN: "Service Confirmation Challan",
    SERVICE_CONFIRMATION_GRN: "Service Confirmation Grn",
    SERVICE_CONFIRMATION_QR: "Service Confirmation Qr",
    SERVICE_CONFIRMATION_PROFORMA_INVOICE: "Service Confirmation Proforma Invoice",
    SERVICE_CONFIRMATION_INVOICE: "Service Confirmation Invoice",
    SERVICE_CONFIRMATION_CREDIT_NOTE: "Service Confirmation Credit Note",
    SERVICE_CONFIRMATION_DEBIT_NOTE: "Service Confirmation Debit Note",
    GATE_ENTRY: "Gate Entry",
    PACKAGING_LIST: "Packaging List",
  },

  DOCUMENT_MAP: {
    Sales: [
      "Sales Lead",
      "Sales Quotation",
      "Sales Order",
      "Delivery Challan",
      "Proforma Invoice",
      "Invoice",
      "Debit Note",
      "Credit Note",
      "Sales Return",
      "Stock Transfer Delivery Challan",
      "Packaging List"
    ],
    Purchase: [
      "Purchase Request",
      "Request for Quotation",
      "Purchase Order",
      "Goods Received Note",
      "Quality Report",
      "Purchase Invoice",
      "Purchase Debit Note",
      "Purchase Credit Note",
      "Purchase Return",
    ],
    Services: [
      "Service Order",
      "Service Challan",
      "Service Grn",
      "Service Qr",
      "Service Proforma Invoice",
      "Service Invoice",
      "Service Debit Note",
      "Service Credit Note"
    ],
    ServicesConfirmation: [
      "Service Confirmation",
      "Service Confirmation Challan",
      "Service Confirmation Grn",
      "Service Confirmation Qr",
      "Service Confirmation Proforma Invoice",
      "Service Confirmation Invoice",
      "Service Confirmation Debit Note",
      "Service Confirmation Credit Note"
    ]
  },

  NOTIFICATION: {
    BILLING_ADDRESS_NOTIFY:
      "Please add Supplier Billing Address from general settings",
  },

  COMPANY_FORM_LABEL: {
    PERSON_CONTACT_DETAIL: "Person Contact Details",
    COMPANY_DETAILS: "Company Details",
    ADDRESS_LABEL: "Addresses",
  },

  ITEM_TABLE_HEADER: {
    ITEM_ID: "Item ID",
    ITEM_NAME: "Item Name",
    HSN_CODE: "HSN Code",
    UOM_CODE: "UOM",
    STORE_NAME: "Store",
    CATEGORY: "Category",
    SUB_CATEGORY: "Sub Category",
    MICRO_CATEGORY: "Micro Category",
    PRICE: "Price",
    DISCOUNT: "Discount (%)",
    ADD_DISCOUNT: "Add. Discount (%)",
    TOTAL_DISCOUNT: "Total Discount",
    TAX_TYPE: "Tax Type",
    TAX: "Tax (%)",
    TOTAL_TAX: "Total Tax",
    TOTAL_BEFORE_TAX: "Total Before Tax",
    TOTAL_AFTER_TAX: "Total After Tax",
    QUANTITY: "Quantity",
    PO_QUANTITY: "PO Quantity",
    RECEIVED_QUANTITY: "Received Quantity",
    PENDING_QUANTITY: "Pending Quantity",
    REJECTED_QUANTITY: "Rejected Quantity",
    APPROVED_QUANTITY: "Approved Quantity",
    IN_STOCK_STORE_NAME: "In Stock Store Name",
    REJECTED_STORE_NAME: "Reject Store Name",
  },

  UOM_DATA_MAPPING: {
    ALERT_MESSAGE: `You can easily manage unit of measurement by adding new ones, editing existing ones, or deleting any you no longer need. This helps keep your content organized and easy to navigate.`,
  },

  DOCUMENT_STATUS,

  BUTTON_REPORT: {
    VIEW_REPORT: "View Report",
  },

  REPORT_TYPE: {
    SALES_REPORT: "salesReport",
    PURCHASE_REPORT: "purchaseReport",
    INVENTORY_REPORT: "inventoryReport",
    PAYMENT_REPORT: "paymentReport",
    PRODUCTION_REPORT: "productionReport",
    GATE_ENTRY_REPORT: "gateEntryReport",
    SERVICE_REPORT: "serviceReport",
  },

  REPORT_PAGE_TEXT: {
    HEADER_TEXT: "Reports Dashboard",
    BODY_TEXT:
      "The Reports Dashboard offers key insights into Inventory, Payments, Sales, and Purchases, empowering businesses to streamline operations and make data-driven decisions. The Inventory Report tracks stock levels and movement to prevent shortages or overstocking. The Payment Report monitors transactions, ensuring smooth cash flow and financial stability. The Sales Report analyzes revenue trends and customer behavior, helping optimize sales strategies and improve performance. The Purchase Report tracks procurement activities, ensuring cost control and timely order management. Together, these reports provide a comprehensive view of business operations, enabling proactive planning and sustainable growth.",
    INVENTORY_REPORT_SHORT_DESC:
      "Tracks stock levels, shortages, and movement to ensure smooth operations.",
    PAYMENT_REPORT_SHORT_DESC:
      "Monitors transaction statuses for better cash flow management.",
    SALES_REPORT_SHORT_DESC:
      "Analyzes revenue trends and customer behavior to optimize sales.",
    PURCHASE_REPORT_SHORT_DESC:
      "Tracks procurement and supplier details for cost control.",
    INVENTORY_REPORT_CARD_TITLE: "Inventory Report",
    PAYMENT_REPORT_CARD_TITLE: "Payment Report",
    SALES_REPORT_CARD_TITLE: "Sales Report",
    PURCHASE_REPORT_CARD_TITLE: "Purchase Report",
    REPORT_PAGE_VIEW_BUTTON: "View Details",
    PRODUCTION_REPORT_CARD_TITLE: "Production Report",
    PRODUCTION_REPORT_SHORT_DESC: "Track work orders, BOM consumption, and finished goods output.",
    GATE_ENTRY_REPORT_CARD_TITLE: "Gate Entry Report",
    GATE_ENTRY_REPORT_SHORT_DESC: "Monitor and manage gate entries for efficient logistics and inventory control.",
    SERVICE_REPORT_CARD_TITLE: "Service Report",
    SERVICE_REPORT_SHORT_DESC: "Track service requests, completions, and customer feedback.",
  },

  TRANSACTION_TYPE: {
    PURCHASE_TRANSACTION: "Purchase Transaction",
    SALES_TRANSACTION: "Sales Transaction",
  },

  TRANSACTION_TEXT_TYPE: {
    LOG_PAYMENT: "Log Payment",
    LOG_TDS: "Log TDS",
  },

  INVENTORY_TABLE_TYPE: {},

  TIMELINE: {
    SALES: "Sales",
    PURCHASE: "Purchase",
  },

  DOCUMENT_FORM_CUSTOM_FIELDS: {
    ALERT_MESSAGE:
      "Add the customize field for primary level and column for item level, if you want to add any specific data.",
  },

  TCS_DOCUMENT_TYPE: [
    "Invoice",
    "Sales Quotation",
    "Sales Order",
    "Proforma Invoice",
    "Credit Note",
    "Debit Note",
    "Delivery Challan",
  ],
  DRAFT_DOC_TYPE,
  PURCHASE_DOCUMENT: [
    "Purchase Order",
    "Goods Received Note",
    "Quality Report",
    "Purchase Invoice",
    "Purchase Request",
    "Request for Quotation",
    "Purchase Debit Note",
    "Purchase Credit Note",
    "Purchase Return",
  ],
  SALES_DOCUMENT: [
    "Sales Lead",
    "Sales Quotation",
    "Sales Order",
    "Delivery Challan",
    "Proforma Invoice",
    "Invoice",
    "Debit Note",
    "Credit Note",
    "Sales Return",
    "Packaging List",
  ],
  PRODUCTION_STATUS
};


export const validFastMovingSlowMovingTypes = ['Fast Moving', 'Slow Moving', 'Non Moving']

export const validStockAnalysisTypes = ['ideal', 'min', 'max'];

export const validStockAgeingTypes = ['0–30 days', '31–60 days', '61–90 days', '91–180 days', '180+ days'];

export const validOnTimeDelayTypes = ['onTime', 'delay'];

export const validWorkOrderStatusTypes = ['inplanning', 'ongoing', 'onhold', 'completed'];

export const DocumentsForApproval = [
  'Sales Quotation',
  'Sales Order',
  'Invoice',
  'Purchase Request',
  'Purchase Order',
  'Purchase Invoice',
  'Service Order',
  'Service Challan',
  'Service Grn',
  'Service Qr',
  'Service Confirmation',
  'Service Confirmation Grn',
  'Service Confirmation Qr',
  'Service Confirmation Challan',
];

export const DocumentTypeDependencies : { [key: string]: string[] } = {
  [AppConstants.DOCUMENT_TYPE.SALES_LEAD]: [],
  [AppConstants.DOCUMENT_TYPE.SALES_QUOTATION]: [AppConstants.DOCUMENT_TYPE.SALES_LEAD],
  [AppConstants.DOCUMENT_TYPE.SALES_ORDER]: [AppConstants.DOCUMENT_TYPE.SALES_QUOTATION],
  [AppConstants.DOCUMENT_TYPE.DELIVERY_CHALLAN] : [AppConstants.DOCUMENT_TYPE.SALES_ORDER],
  [AppConstants.DOCUMENT_TYPE.PROFORMA_INVOICE] : [AppConstants.DOCUMENT_TYPE.SALES_ORDER],
  [AppConstants.DOCUMENT_TYPE.INVOICE] : [AppConstants.DOCUMENT_TYPE.SALES_ORDER, AppConstants.DOCUMENT_TYPE.PROFORMA_INVOICE],
  [AppConstants.DOCUMENT_TYPE.DEBIT_NOTE] : [AppConstants.DOCUMENT_TYPE.INVOICE],
  [AppConstants.DOCUMENT_TYPE.CREDIT_NOTE] : [AppConstants.DOCUMENT_TYPE.INVOICE],
  [AppConstants.DOCUMENT_TYPE.SALES_RETURN] : [AppConstants.DOCUMENT_TYPE.SALES_ORDER, AppConstants.DOCUMENT_TYPE.INVOICE],
  [AppConstants.DOCUMENT_TYPE.PACKAGING_LIST] : [AppConstants.DOCUMENT_TYPE.INVOICE],

  [AppConstants.DOCUMENT_TYPE.PURCHASE_REQUEST] : [AppConstants.DOCUMENT_TYPE.SALES_ORDER],
  [AppConstants.DOCUMENT_TYPE.REQUEST_FOR_QUOTATION] : [AppConstants.DOCUMENT_TYPE.PURCHASE_REQUEST],
  [AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER] : [AppConstants.DOCUMENT_TYPE.PURCHASE_REQUEST, AppConstants.DOCUMENT_TYPE.REQUEST_FOR_QUOTATION],
  [AppConstants.DOCUMENT_TYPE.GOODS_RECEIVED_NOTE] : [AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER],
  [AppConstants.DOCUMENT_TYPE.QUALITY_REPORT] : [AppConstants.DOCUMENT_TYPE.GOODS_RECEIVED_NOTE],
  [AppConstants.DOCUMENT_TYPE.PURCHASE_INVOICE] : [AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER],
  [AppConstants.DOCUMENT_TYPE.PURCHASE_DEBIT_NOTE] : [AppConstants.DOCUMENT_TYPE.PURCHASE_INVOICE, AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER],
  [AppConstants.DOCUMENT_TYPE.PURCHASE_CREDIT_NOTE] : [AppConstants.DOCUMENT_TYPE.PURCHASE_INVOICE, AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER],
  [AppConstants.DOCUMENT_TYPE.PURCHASE_RETURN] : [AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER],

  [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER] :[],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CHALLAN] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  [AppConstants.DOCUMENT_TYPE.SERVICE_GRN] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER , AppConstants.DOCUMENT_TYPE.SERVICE_CHALLAN],
  [AppConstants.DOCUMENT_TYPE.SERVICE_QR] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER, AppConstants.DOCUMENT_TYPE.SERVICE_GRN],
  [AppConstants.DOCUMENT_TYPE.SERVICE_PROFORMA_INVOICE] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  [AppConstants.DOCUMENT_TYPE.SERVICE_INVOICE] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  [AppConstants.DOCUMENT_TYPE.SERVICE_DEBIT_NOTE] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CREDIT_NOTE] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION] : [AppConstants.DOCUMENT_TYPE.SERVICE_ORDER],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_GRN] : [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_QR] : [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_GRN],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_CHALLAN] : [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_GRN],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_PROFORMA_INVOICE] : [],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_INVOICE] : [],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_DEBIT_NOTE] : [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_INVOICE],
  [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_CREDIT_NOTE] : [AppConstants.DOCUMENT_TYPE.SERVICE_CONFIRMATION_INVOICE]
} 
